import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';

export interface IOpenAccount {
  selectedAccountTypeId: any;
  decedentInfo: any;
  personalInfo: any;
  contactInfo: any;
  fundingMethod: string;
  employmentInfo: any;
  goals: any;
  incomeNetWorth: any;
  sources: any;
  isProspect: boolean;
  settlementFund?: SettlementFundAoAEnum;
}
